export default "__VITE_PUBLIC_ASSET__cb4f6d3f__"